import React from "react";
import { Link } from "react-router-dom";
import { Stars, Img } from "./Primitives";
import { useCart } from "../context/CartContext";

const fmt = (n) => `${n} €`;

export const ProductCard = ({ product, wide = false, badge = null, imageOverride = null }) => {
  const soldOut = product.stock <= 0;
  const imgSrc = imageOverride || product.image;
  return (
    <div className="card" data-testid={`product-card-${product.id}`}
      style={{ overflow: "hidden", display: wide ? "grid" : "block", gridTemplateColumns: wide ? "1fr 1fr" : undefined }}>
      <Link to={product.route} style={{ display: "block", position: "relative" }}>
        {badge && <span className="crush-badge" style={{ position: "absolute", top: 12, left: 12, zIndex: 2, background: "rgba(10,10,10,0.7)" }}>{badge}</span>}
        <Img src={imgSrc} alt={product.name} sizes="(min-width:900px) 33vw, 100vw"
          style={{ width: "100%", aspectRatio: wide ? "16/12" : "1/1", objectFit: "cover", display: "block" }} />
      </Link>
      <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 10, justifyContent: "center" }}>
        <h3 className="display" style={{ margin: 0, fontSize: 18, textTransform: "uppercase", letterSpacing: "0.02em" }}>{product.name}</h3>
        <Stars rating={product.rating} count={product.review_count} />
        <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
          <span className="price" style={{ fontSize: 22 }}>{fmt(product.price_eur)}</span>
          {product.anchor_price_eur && <span className="price-strike" style={{ fontSize: 14 }}>{fmt(product.anchor_price_eur)}</span>}
        </div>
        {soldOut ? (
          <button className="btn btn-disabled" disabled data-testid={`soldout-${product.id}`}>Bientôt de retour</button>
        ) : (
          <Link to={product.route} className="btn btn-secondary" data-testid={`view-${product.id}`}>Voir le produit</Link>
        )}
      </div>
    </div>
  );
};

export const AddToCartInline = ({ product }) => {
  const { addItem } = useCart();
  return (
    <button className="btn btn-primary" data-testid={`quick-add-${product.id}`}
      onClick={() => addItem(product.id, product.variants && product.variants.length ? product.variants[0] : null)}>
      Ajouter directement au panier
    </button>
  );
};
